var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreelancerDashboardIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75321 2.00195H14.7532C15.1214 2.00195 15.4199 2.30043 15.4199 2.66862V13.3353C15.4199 13.7035 15.1214 14.0019 14.7532 14.0019H2.75321C2.38503 14.0019 2.08655 13.7035 2.08655 13.3353V2.66862C2.08655 2.30043 2.38503 2.00195 2.75321 2.00195ZM3.41988 3.33529V12.6686H14.0866V3.33529H3.41988ZM6.41988 9.33527H10.0866C10.2706 9.33527 10.4199 9.18607 10.4199 9.00193C10.4199 8.81787 10.2706 8.6686 10.0866 8.6686H7.41989C6.49941 8.6686 5.75321 7.9224 5.75321 7.00193C5.75321 6.08148 6.49941 5.33529 7.41989 5.33529H8.08656V4.00195H9.41989V5.33529H11.0866V6.6686H7.41989C7.23579 6.6686 7.08655 6.81787 7.08655 7.00193C7.08655 7.18607 7.23579 7.33527 7.41989 7.33527H10.0866C11.007 7.33527 11.7532 8.08147 11.7532 9.00193C11.7532 9.9224 11.007 10.6686 10.0866 10.6686H9.41989V12.0019H8.08656V10.6686H6.41988V9.33527Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancerDashboardIcon04);
export default __webpack_public_path__ + "static/media/freelancer-dashboard-icon-04.36025217ca9d7e949ec1f2608ad6478a.svg";
export { ForwardRef as ReactComponent };